import { z } from 'zod';
import { toFlatField } from '../oasis-types';
export const baseMouthNoseThroat = z.object({
    wnl: z.boolean().optional(),
    status: z.array(z.string()).optional(),
});
export const baseMouthNoseThroatRefined = baseMouthNoseThroat.refine((data) => data.wnl || data.status?.length, {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
export const SectionBVersioned = {
    b0200: {
        e1: { alias: 'b0200', timepoint: ['soc'], tags: ['PRA'] },
        e2: { alias: 'b0200', timepoint: ['soc', 'roc'], tags: ['PRA'] },
    },
    hearing: {
        e1: { alias: 'hearing', timepoint: ['soc', 'roc', 'rct', 'dsch'] },
    },
    b1000: {
        e1: { alias: 'b1000', timepoint: ['soc'], tags: ['PRA'] },
        e2: { alias: 'b1000', timepoint: ['soc', 'roc'], tags: ['PRA'] },
    },
    vision: {
        e1: { alias: 'vision', timepoint: ['soc', 'roc', 'rct', 'dsch'] },
    },
    mouthNoseThroat: {
        e1: { alias: 'mouthNoseThroat', timepoint: ['soc', 'roc', 'rct', 'dsch'] },
    },
    neurological: {
        e1: { alias: 'neurological', timepoint: ['soc', 'roc', 'rct', 'dsch'] },
    },
    b1300: {
        e1: { alias: 'b1300', timepoint: ['soc', 'roc', 'dsch'], tags: ['PRA'] },
    },
};
export const SectionB = toFlatField(SectionBVersioned);
// B-B0200-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Adequate - no difficulty in normal conversation, social interaction, listening to TV"},{"value":"1","label":"Minimal difficulty - difficulty in some environments (e.g., when person speaks softly or setting is noisy)"},{"value":"2","label":"Moderate difficulty - speaker has to increase volume and speak distinctly"},{"value":"3","label":"Highly impaired - absence of useful hearing"},{"value":"-","label":"Not assessed/no information"}]
// B-B1000-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Adequate - sees fine detail, such as regular print in newspapers/books"},{"value":"1","label":"\\tImpaired - sees large print, but not regular print in newspapers/books"},{"value":"2","label":"Moderate impaired - limited vision; not able to see newspaper headlines but can identify objects"},{"value":"3","label":"Highly impaired - object identification in question, but eyes appear to follow objects"},{"value":"4","label":"Severely impaired - no vision or sees only light, colors or shapes; eyes do not appear to follow objects"},{"value":"-","label":"Not assessed/no information"}]
// B-B1300-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Never"},{"value":"1","label":"Rarely"},{"value":"2","label":"Sometimes"},{"value":"3","label":"Often"},{"value":"4","label":"Always"},{"value":"8","label":"Patient unable to respond"},{"value":"7","label":"Patient declines to respond"}]
